var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowleft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.73,
    cx: 55.5,
    cy: 55.5,
    r: 55.5,
    fill: "#14467C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.0607 57.0607C77.6464 56.4749 77.6464 55.5251 77.0607 54.9393L67.5147 45.3934C66.9289 44.8076 65.9792 44.8076 65.3934 45.3934C64.8076 45.9792 64.8076 46.9289 65.3934 47.5147L73.8787 56L65.3934 64.4853C64.8076 65.0711 64.8076 66.0208 65.3934 66.6066C65.9792 67.1924 66.9289 67.1924 67.5147 66.6066L77.0607 57.0607ZM35 57.5L76 57.5L76 54.5L35 54.5L35 57.5Z",
    fill: "#F0EFF4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowleft);
export default __webpack_public_path__ + "static/media/arrowleft.cdbd34565a01f221a0e3cacd6946d7a7.svg";
export { ForwardRef as ReactComponent };